import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import BeatLoader from "react-spinners/BeatLoader";
import { FaEdit, FaCheck, FaTimes, FaPencilAlt } from "react-icons/fa";
import { Box, TextField } from "@mui/material";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import {
  createTheme,
  ThemeProvider,
  alpha,
  styled,
} from "@mui/material/styles";
import { DataGridPro, gridClasses, GridToolbar } from "@mui/x-data-grid-pro";

import "../StudySetup.css";
import { getAllDrugReturnConfigService } from "./DrugReturnConfig";

const getMuiTheme = createTheme({
  typography: {
    fontSize: 25,
  },
  ".css-1x51dt5-MuiInputBase-input-MuiInput-input": {
    color: "#000000 !important",
  },
});

const ODD_OPACITY = 0.2;

const StripedDataGrid = styled(DataGridPro)(({ theme }) => ({
  [`& .${gridClasses.row}.even`]: {
    backgroundColor: theme.palette.grey[200],
    "&:hover, &.Mui-hovered": {
      backgroundColor: alpha(theme.palette.primary.main, ODD_OPACITY),
      "@media (hover: none)": {
        backgroundColor: "transparent",
      },
    },
    "&.Mui-selected": {
      backgroundColor: alpha(
        theme.palette.primary.main,
        ODD_OPACITY + theme.palette.action.selectedOpacity
      ),
      "&:hover, &.Mui-hovered": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          ODD_OPACITY +
            theme.palette.action.selectedOpacity +
            theme.palette.action.hoverOpacity
        ),
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: alpha(
            theme.palette.primary.main,
            ODD_OPACITY + theme.palette.action.selectedOpacity
          ),
        },
      },
    },
  },
}));

const DrugReturnConfig = () => {
  const navigate = useNavigate();

  const [load, setLoad] = React.useState(false);

  const [returnDrugData, setReturnDrugData] = React.useState([]);

  const [pageSize, setPageSize] = React.useState(12);

  const rows = returnDrugData.map((row) => ({
    id: row.id,
    name: row.name,
    edit: row.id,
    link: row.link,
  }));

  const columns = [
    // {
    //   field: "id",
    //   hide: true,
    //   headerName: "ID",
    //   width: 0,
    //   renderHeader: () => <div className="grid-heading-id">{"ID"}</div>,
    //   renderCell: (params) => {
    //     const id = params.row.id;

    //     return (
    //       <div className="grid-id">
    //         <p>{id}</p>
    //       </div>
    //     );
    //   },
    // },
    {
      field: "name",
      headerName: "Name",
      renderHeader: () => <div className="grid-heading">{"Name"}</div>,
      width: "1100",
      renderCell: (params) => {
        const name = params.row.name;

        return (
          <div className="grid-body">
            <p>{name}</p>
          </div>
        );
      },
    },
    {
      field: "edit",
      headerName: "Edit",
      renderHeader: () => <div className="grid-heading">{"Edit"}</div>,
      width: "50",
      renderCell: (params) => {
        const id = params.row.id;
        return (
          <button
            style={{
              cursor: "pointer",
              textAlign: "center",
              backgroundColor: "#337ab7",
              padding: "8px",
              border: "none",
              borderRadius: "5px",
            }}
            onClick={async () => {
              navigate(`/study-management/drug-return-page`, {
                state: {
                  id: id,
                },
              });
            }}
          >
            <FaPencilAlt color="white" size={15} />
          </button>
        );
      },
    },
    // {
    //   field: "link",
    //   hide: true,
    //   headerName: "Link",
    //   renderHeader: () => <strong>{"Link"}</strong>,
    //   width: "240",
    // },
  ];

  const fetchAllDrugReturnConfigs = async () => {
    setLoad(true);
    try {
      const res = await getAllDrugReturnConfigService();
      if (res?.status) {
        setLoad(false);
        setReturnDrugData(res?.data?.result);
      }
    } catch (err) {
      setLoad(false);
      console.log("Error :", err.message);
    }
  };

  useEffect(() => {
    fetchAllDrugReturnConfigs();
  }, []);

  return (
    <>
      {load ? (
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "70vh",
            }}
          >
            <BeatLoader color="#3661eb" />
          </div>
        </>
      ) : (
        <div className="content-body">
          <p className="study-management-link" style={{ fontWeight: "600" }}>
            <Link to="/study-management">Manage Your Study</Link> |{" "}
            <Link to="/study-management/drug-return">Drug Return</Link>-{" "}
            <b style={{ color: "gray" }}>
              {sessionStorage?.getItem("studyName")}
            </b>
          </p>
          <Row style={{ marginTop: "2%", marginBottom: "2%" }}>
            <Col md={6}>
              <div className="study-management-head-start">
                <p className="study-management-heading">
                  Drug Return control configuration
                </p>
              </div>
            </Col>
            <Col md={6}>
              {/* <Link to="/study-management/dispensations/create">
                <div className="study-management-head-end">
                  <button className="study-management-create-btn-md">
                    Create Dispensation
                  </button>
                </div>
              </Link> */}
            </Col>
          </Row>

          <Box sx={{ height: 550, width: "100%", display: "flex" }}>
            <ThemeProvider theme={getMuiTheme}>
              <StripedDataGrid
                className="allQuestionnaire-grid"
                rows={rows}
                columns={columns}
                pageSize={pageSize}
                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                rowsPerPageOptions={[5, 10, 20]}
                components={{ Toolbar: GridToolbar }}
                pagination
                rowHeight={40}
                disableSelectionOnClick
                experimentalFeatures={{ newEditingApi: true }}
                getRowClassName={(params) =>
                  params.indexRelativeToCurrentPage % 2 === 0 ? "even" : "odd"
                }
              />
            </ThemeProvider>
          </Box>

          <Row style={{ marginTop: "2%" }}>
            <Col md={6}></Col>
            <Col md={6}>
              <Link to="/study-management">
                <div className="study-management-head-end">
                  <button className="study-management-create-btn-lg">
                    Back
                  </button>
                </div>
              </Link>
            </Col>
          </Row>
        </div>
      )}
    </>
  );
};

export default DrugReturnConfig;
